import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Layout per le pagine di autenticazione: card centrata, landmark completi.
 * L'h1 è il primo contenuto del main: gli screen reader atterrano subito sul contesto.
 */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <>
      <a href="#contenuto" className="skip-link">
        Salta al contenuto principale
      </a>
      <div className="flex min-h-screen flex-col">
        <header className="border-b border-ink-200 px-4 py-3 dark:border-ink-800">
          <Link to="/" className="inline-flex items-center gap-2 text-xl font-bold no-underline">
            <img src="/favicon.png" alt="" width={36} height={36} className="h-9 w-9" />
            PandaCalcio
          </Link>
        </header>
        <main id="contenuto" className="flex flex-1 items-start justify-center px-4 py-10 sm:items-center">
          <div className="w-full max-w-md rounded-2xl border border-ink-200 bg-white p-6 shadow-sm sm:p-8 dark:border-ink-800 dark:bg-ink-900">
            <h1 className="mb-6 text-2xl font-bold tracking-tight">{title}</h1>
            {children}
          </div>
        </main>
      </div>
    </>
  );
}
